import React from "react";

import CountryFlag from "../../../../components/CountryFlag";
import TextAttributeForm from "../../../../components/AttributeForm/TextAttributeForm";
import AttributeList from "../../../../components/AttributeList";
import {useHome} from "../HomeContext";
import {useHomeAction} from "../HomeActionContext";



const HomeDescription = () => {
    const {descriptionIt, descriptionEn,} = useHome();
    const {formDescriptionIt, formDescriptionEn, handleSubmit} = useHomeAction();

    const attributes = [
        {
            label: "Descrizione (italiano)",
            value: descriptionIt,
            defaultValue: "Non presente",
            icon: <CountryFlag code="IT"/>,
            formDialog: formDescriptionIt,
            formComponent: <TextAttributeForm attribute="descriptionIt"
                                              label="Descrizione (italiano)"
                                              value={descriptionIt}
                                              onClose={formDescriptionIt.close}
                                              onSubmit={(data) => handleSubmit(formDescriptionIt, data)}
                                              multiline={true}
                                              rows={10}
                                              isLoading={formDescriptionIt.loading}/>
        },
        {
            label: "Descrizione (inglese)",
            value: descriptionEn,
            defaultValue: "Non presente",
            icon: <CountryFlag code="GB"/>,
            formDialog: formDescriptionEn,
            formComponent: <TextAttributeForm attribute="descriptionEn"
                                              label="Descrizione (inglese)"
                                              value={descriptionEn}
                                              onClose={formDescriptionEn.close}
                                              onSubmit={(data) => handleSubmit(formDescriptionEn, data)}
                                              multiline={true}
                                              rows={10}
                                              isLoading={formDescriptionEn.loading}/>
        },
    ]

    return <AttributeList attributes={attributes}/>
}

export default HomeDescription;